import React from "react";
import { MobilePreviewcomponentMap } from "./MobilePreviewMap";

type BlockProp = {
  block: any;
};

const MobConsentBlock: React.FC<BlockProp> = ({ block }) => {
  const Component = MobilePreviewcomponentMap[block.type];

  return <>{Component && <Component currentBlock={block} />}</>;
};

export default React.memo(MobConsentBlock);
